export const removeNonAsciiCharacters = (str: string): string =>
  str.replace(/[^\x00-\x7F]/g, '')
